// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1D72F","footer":"ChangeClinic_footer__UMu9z"};